<template>
    <div class="box tqm">
        <div class="box-head bg-color1 felx-between">
            <div class="box-head-title color1 flex-algin">
                <!-- 质量分项验收管理
                <i class="el-icon-arrow-down color1" style="margin-left:10px;"></i> -->
                <!-- <ul>
                    <li>质量分项验收管理</li>
                    <li>质量分部验收管理</li>
                </ul>
                <i class="el-icon-arrow-down color1" style="margin-left:10px;"></i> -->
                <el-select v-model="type" popper-class="fen-sel" class="fen-val" placeholder="选择检索项目"  @change="doFilte">
                    <el-option
                    v-for="item in tqmTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" class="bg-color2" @click="toInfo">验收</el-button>
        </div>
        <div class="box-table">
            <el-table
            :data="tableList"
            height="100%"
            style="width: 100%;border:0;"
            :header-cell-class-name="tableHeadCellName"
            :header-row-class-name="tableHeadRowName"
            :row-class-name="tableRowClassName">
                <el-table-column prop="projectName" label="来源项目" align="center"></el-table-column>
                <el-table-column prop="acceptanceContent" label="验收事项" align="center"></el-table-column>
                <!-- <el-table-column prop="address" label="验收次数" align="center"></el-table-column> -->
                <el-table-column prop="createDate" label="验收时间" align="center"></el-table-column>
                <el-table-column prop="personName" label="验收人" align="center"></el-table-column>
                <el-table-column label="结果" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" class="bg-color3" v-if="scope.row.standardStatus=='1'">未达标</el-button>
                    <el-button size="mini" type="primary" class="bg-color4" v-else>达标</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="showFun(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="width:100%;background:#fff;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                style="padding-top:10px;">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            tableList:[],
            tableHeadCellName:'table-head-cell',
            tableHeadRowName:'table-head-row',
            tqmTypes:[
                {id:'0',name:'质量分项验收管理'},
                {id:'1',name:'质量分部验收管理'}
            ],
            type:'0',
            groupId:'',
            currentPage:1,
            pageSize:10,
            totalItems:0,
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
        this.getData()
    },
    methods:{
        doFilte(){
            this.currentPage = 1
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //获取数据
        getData(){
            var that = this
            myHttp.secAcceptanceRecord({
                entId:this.groupId,
                joinType:'2',
                acceptanceType:this.type,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if (resp.data.code == '200') {
                    var list = resp.data.data.list.list || []
                    var result = []
                    for(var i=0;i<list.length;i++){
                        list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        result.push(list[i])
                        // result.push({})
                    }
                    that.tableList = result
                    if(that.totalItems==0){
                        that.totalItems = resp.data.data.list.total
                    }
                }
            })
        },
        tableRowClassName({row, rowIndex}) {
            // if (rowIndex%2 === 0) {
            // return 'full-row';
            // } else if (rowIndex%2 === 1) {
            // return 'null-row';
            // }
            return 'full-row';
        },
        //跳转详情
        toInfo(){
            this.$router.push({ path: '/tqmInfo/0/'+this.type })
        },
        //查看详情
        showFun(row){
            this.$router.push({ path: '/tqmInfo/'+row.id+'/'+this.type })
        },
    },
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width: 100%;
        position: relative;
        height: calc( 100vh - 170px );
        /* background: #010D27; */
    }
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 100px );
        position: relative;
        /* overflow: auto; */
    }
    .el-table .box-head-title{
        font-size: 16px;
    }


    .flex-algin{
        display: flex;
        align-content: center;
        align-items: center;
    }
    .felx-between{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .bg-color1{
        background: #001498;
    }
    .bg-color2{
        background: #0D2DFF;
    }
    .bg-color3{
        background: #FFBC01;
    }
    .bg-color4{
        background: #36C635;
    }
    .color1{
        color: #17B2FE;
    }
</style>
<style>
    .tqm .el-table .table-head-cell,.tqm .table-head-row{
        /* background: #010D27; */
        color: #4C9AFF;
        font-size: 18px;
        text-align: center;
    }
    .tqm .el-table .full-row{
        /* background: #031260 !important; */
        color: #4C9AFF;
        font-size: 18px;
        text-align: center;
    }
    .tqm .el-table .null-row{
        /* background: #010D27 !important; */
        border: 0;
        height: 10px;
        
    }
    .tqm .el-table .el-table__empty-block{
        /* background: #031260; */
        color: #4C9AFF;
        font-size: 18px;
        border: 0;
    }
    .tqm .el-table td,.tqm .el-table th.is-leaf{
        border: 0;
    }
    /* .tqm .el-table td{
        border-bottom: 10px solid #010d27;
    } */
    .tqm .el-table--enable-row-hover .el-table__body tr:hover>td,.tqm .el-table,.tqm .el-table__expanded-cell{
        background-color:inherit;
    }
    .fen-val .el-input__inner{
        background: transparent;
        border: 0;
        font-size: 16px;
        text-align: right;
        color: #4C9AFF;
    }
    .fen-sel.el-popper{
        background: #001498;
        margin-top:1px;
        border: 0;
    }
    .fen-sel .el-select-dropdown__empty{
        color: #fff;
    }
    .fen-val.el-select .el-input{
        width: 200px;
    }
    .fen-sel .popper__arrow{
        display: none;
    }
    .fen-sel .el-select-dropdown__item{
        border: 0;
        /* background: #010D27; */
        color: #4C9AFF;
    }
    .fen-sel .el-select-dropdown__item.hover,.fen-sel .el-select-dropdown__item:hover{
        border: 0;
        background: rgb(50, 78, 226);
        color: #4C9AFF;
    }
    .fen-sel .el-select-dropdown__list{
        padding: 0;
    }
    .tqm .el-pagination{
        background: inherit;
    }
    /* .tqm .el-pagination span{
        color: white;
    } */
    /* .tqm .el-pagination .el-input__inner{
        background: transparent;
        color: white;
    } */
</style>